/**
 * Gets a CSS custom property value from the document root
 *
 * @param property - The CSS custom property name (e.g., '--token-brand-400')
 * @param fallback - Fallback value if property is not found
 * @returns The computed value or fallback
 */ export function getThemeColor(property, fallback) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(property).trim();
    return value || fallback;
}
